<div *ngIf="control.visible" class="form-group row" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
  <div class="col-md-12" >
    <ng-select
      class="hb-dropdown hb-loading-dropdown"
      #select
      [items]="control.options"
      [virtualScroll]="false"
      [loading]="control.loading"
      bindLabel="label"
      bindValue="value"
      [placeholder]="control.placeholder || control.label"
      [typeahead]="input$"
      (scrollToEnd)="fetchMore()"
      (close)="onClose()"
      [formControlName]="control.key"
      (open)="onDropdownOpen()"
      notFoundText="{{ 'Dropdown.ItemNotFound' | i18next }}"
    >
      <ng-template ng-option-tmp let-item="item">
        <div title="{{ item.title }}">{{ item.label }}</div>
      </ng-template>
    </ng-select>
  </div>
</div>
